<template>
  <div>
    <admin-simple-table :field_list="tableData"
                        :items="tableItems"
                        :filtered="filtered"
                        :allCount="allCount"
                        :filteredCount="filteredCount"
                        :table_width="1800"
                        @getData="getDataFromServer"
                        @ordering="ordering"
                        @selPageLength="selPageLength">

      <div slot="checkspot" slot-scope="props">
        <lp-check-bool
          v-if="checkArr[props.idx]!==undefined"
          :checkedVal.sync="checkArr[props.idx].value"></lp-check-bool>
      </div>

      <div slot="enable_approval" slot-scope="props" style="width: 120px; margin: auto;">
        <button class="button half is-primary" style="margin-right:4px" @click="clickApprovalOne('approval', props.item)">승인</button>
        <button class="button half" @click="clickApprovalOne('unapproval', props.item)">미승인</button>
      </div>

      <div slot="content" slot-scope="props">
        <div @click.stop.prevent="openContentModal(props.item)" style="cursor: pointer" v-if="props.item.content.length>0">
          <i class="material-icons">library_books</i>
        </div>
        <div v-else>-</div>
      </div>

      <div slot="spot" v-if="tableItems.length > 0">
        <div style="background-color: #eee; padding: 8px">
          <button class="button is-primary" style="margin-right:4px" @click="clickApproval('approval')">선택 승인</button>
          <button class="button" @click="clickApproval('unapproval')">선택 미승인</button>
        </div>
      </div>

    </admin-simple-table>

    <modal name="contentModal" :adaptive="true" :width="600" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        <div v-for="(item, idx) in selectedContent" :key="`item-${idx}`">
          <admin-form-item :label="item.name" style="margin-top:8px">
            {{ item.field==='gender' ? (item.value==='female' ? '여' : '남') : item.value  }}
          </admin-form-item>
        </div>
      </div>
    </modal>

  </div>
</template>

<script>
  import ListMixin from '@/mixins/ListMixin'
  import LpCheckBool from "../../module/common/LpCheckBool";
  import AdminFormItem from "../../module/admin/AdminFormItem";

  export default {
    name: 'UserGradeApprovalNew',
    components: {
      AdminFormItem,
      LpCheckBool},
    mixins: [
      ListMixin
    ],
    data () {
      return {
        // 선택된 체크박스
        checkArr: [],
        selectedContent: []
      }
    },

    created(){
      this.init();
    },
    methods: {
      init() {
        this.initializing('member_grade_approve_new', 'member/grade/approve/new?status=0');
      },
      getDataFromServer() {
        this.getData();
      },
      openContentModal (item) {
        this.selectedContent = item.content;
        this.$modal.show('contentModal');
      },
      clickItem(item, types) {
        // 수정
        if (types === 'update') {
          this.$router.push('user/create?id=' + item.id);
        }
        // 삭제
        else if (types === 'delete') {

          let value = {
            id: item.id,
            url: 'member/user/',
            title: '회원등급 승인을 삭제하시겠습니까?'
          }
          this.$store.commit('openModal', {type: 'modal-delete', value: value, width: 500});
          // this.modalSignout = item.id;
          // this.$refs.signoutModal.open();
        }
      },

      // 아이템 하나 선택 했을 경우
      clickApprovalOne(type, item){
        if( type === 'approval') {
          this.$axios.post(this.getUrl('member/grade/approve/'+item.id), {
            type: 'approval'
          }).then(res=>{
            if(res.status===200) {
              this.toast('승인 완료되었습니다');
              this.getData();
            }
          }).catch(error=>{
            if(error.response){
              this.toast(error.response.detail);
            }
          })
        }
        else if( type === 'unapproval') {
          this.$axios.post(this.getUrl('member/grade/approve/'+item.id), {
            type: 'unapproval'
          }).then(res=>{
            if(res.status===200) {
              this.toast('미승인 완료되었습니다');
              this.getData();
            }
          })
        }
      },

      // 체크박스로 다수 선택 하고 호출할 경우
      clickApproval(type){
        if( type === 'approval') {
          let id_list = this.getCheckedArr();
          if(id_list.length===0){
            return;
          }

          this.$axios.post(this.getUrl('member/grade/approve/multiple'), {
            approvals: id_list,
            type: 'approval'
          }).then(res=>{
              if(res.status===200) {
                this.toast('승인 완료되었습니다');
                this.getData();
              }
            }).catch(error=>{
            if(error.response){
              this.toast(error.response.detail);
            }
          })
        }
        else if( type === 'unapproval') {
          let id_list = this.getCheckedArr();
          if(id_list.length===0){
            return;
          }

          this.$axios.post(this.getUrl('member/grade/approve/multiple'), {
            approvals: id_list,
            type: 'unapproval'
          }).then(res=>{
            if(res.status===200) {
              this.toast('미승인 완료되었습니다');
              this.getData();
            }
          })
        }
      },

      //  체크된 id들 가져오기
      getCheckedArr(){
        let id_list = [];
        for(let i=0; i<this.checkArr.length; i++){
          if(this.checkArr[i].value){
            id_list.push(this.checkArr[i].id);
          }
        }

        return id_list;
      },

      getData() {
        this.$axios.get(this.getUrl('member/grade/approve/new?status=0'), {
          params: this.filtered
        }).then(res=>{
          if (res.status === 200) {
            // console.log(res)
            this.tableItems = res.data.data;
            this.filtered.page_length = res.data.page_length;
            this.filtered.cur_page = res.data.cur_page;
            this.filtered.total_page = res.data.total_page;
            this.allCount = res.data.total_count;
            this.filteredCount = res.data.count;

            let tableList = [];
            for(let i=0; i<this.tableItems.length; i++){
              tableList.push ({id: this.tableItems[i].id, value: false});
            }
            this.checkArr = tableList;
          }
        })
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>

</style>
